import {
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Slide,
  Typography,
  Tooltip,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormLabel,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Cancel, Close, Help, Block, CheckCircle, Compare, Shuffle } from "@material-ui/icons";
import { displayName } from "../helper/DisplayUtil";
import { BirthSexOptions, MatchStatus } from "../../Base/AdoptionConstants";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import moment from "moment";
import {
  addMatchRecord,
  findExistingMatch,
  updateMatchNotes,
  updateMatchStatus,
} from "../../Base/Services/MatchService";
import useAdminContext from "../AdminContextProvider";
import RegistrationMatchComponent from "../RegistrationMatchComponent/RegistrationMatchComponent";
import useAlerts from "../../Base/AlertProvider";
import { Formik } from "formik";
import FormikTextField from "../../Base/Components/FormikTextField";

const useStyles = makeStyles((theme) => ({
  keyChart: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  registrationLink: {
    cursor: "pointer",
  },
  responsiveDialog: {
    [theme.breakpoints.down("xs")]: {
      margin: 0,
      maxWidth: "100%",
      width: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
    },
  },
  compactTitle: {
    [theme.breakpoints.down("sm")]: {
      padding: "0.25rem 0.5rem",
    },
  },
  compactActions: {
    [theme.breakpoints.down("sm")]: {
      padding: "0.25rem 0.5rem",
    },
  },
  compactContent: {
    [theme.breakpoints.down("sm")]: {
      padding: "0.25rem 0.5rem",
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AdopteefieldsToMatch = [
  {
    label: "Adoptee Current Name",
    getDisplay: (reg) =>
      displayName(reg?.adopteeCurrentFirstName, reg?.adopteeCurrentMiddleName, reg?.adopteeCurrentLastName),
  },
  {
    label: "Birth Name",
    getDisplay: (reg) =>
      displayName(reg?.adopteeBirthFirstName, reg?.adopteeBirthMiddleName, reg?.adopteeBirthLastName),
  },
  {
    label: "Adoptive Name",
    getDisplay: (reg) =>
      displayName(reg?.adopteeAdoptiveFirstName, reg?.adopteeAdoptiveMiddleName, reg?.adopteeAdoptiveLastName),
  },
  {
    label: "Adoptee Birth Date",
    getDisplay: (reg) =>
      reg?.birthDate
        ? moment(reg?.birthDate).format("LL")
        : `${moment(reg?.birthDateRangeStart).format("LL")} - ${moment(reg?.birthDateRangeEnd).format("LL")}`,
    isMatch: (reg1, reg2) => {
      if (reg1?.birthDate && reg2?.birthDate && reg1?.birthDate === reg2?.birthDate) {
        return "MATCH";
      }
      if (!reg1?.birthDate && reg2?.birthDate) {
        if (reg2?.birthDate >= reg1?.birthDateRangeStart && reg2?.birthDate <= reg1?.birthDateRangeEnd) {
          return "MATCH";
        }
      }
      if (!reg2?.birthDate && reg1?.birthDate) {
        if (reg1?.birthDate >= reg2?.birthDateRangeStart && reg1?.birthDate <= reg2?.birthDateRangeEnd) {
          return "MATCH";
        }
      }
      if (!reg1?.birthDate && !reg2?.birthDate) {
        if (
          (reg1?.birthDateRangeStart >= reg2?.birthDateRangeStart &&
            reg1?.birthDateRangeEnd <= reg2?.birthDateRangeEnd) ||
          (reg2?.birthDateRangeStart >= reg1?.birthDateRangeStart && reg2?.birthDateRangeEnd <= reg1?.birthDateRangeEnd)
        ) {
          return "MATCH";
        }
      }
    },
  },
  {
    label: "Birth Hospital",
    getDisplay: (reg) => reg?.birthHospital,
  },
  {
    label: "Other Birth Location",
    getDisplay: (reg) => reg?.otherBirthLocation,
  },
  {
    label: "Gender",
    getDisplay: (reg) => (reg?.birthSex ? BirthSexOptions.find((sex) => sex.value === reg?.birthSex).label : "-"),
  },
  {
    label: "Adoption Agency Attorney",
    getDisplay: (reg) => reg?.adoptionAgencyAttorney,
  },
];

const AdopteeParentsFieldsToMatch = [
  {
    label: "First Adoptee Parent's Name",
    getDisplay: (reg) =>
      displayName(reg?.adoptiveParent1FirstName, reg?.adoptiveParent1MiddleName, reg?.adoptiveParent1LastName),
    isMatch: (reg1, reg2) => {
      const selectedName1 =
        reg1?.adoptiveParent1FirstName + reg1?.adoptiveParent1MiddleName + reg1?.adoptiveParent1LastName;
      const matchName1 =
        reg2?.adoptiveParent1FirstName + reg2?.adoptiveParent1MiddleName + reg2?.adoptiveParent1LastName;
      const matchName2 =
        reg2?.adoptiveParent2FirstName + reg2?.adoptiveParent2MiddleName + reg2?.adoptiveParent2LastName;
      // if selectedNames1 and matchName1 have no data
      if (!selectedName1 || !matchName1) {
        return "NO_DATA";
      }

      // if selectedName1 match matchName1
      if (selectedName1 === matchName1) {
        return "MATCH";
      }

      // if selectedName1 cross matches matchName2
      if (selectedName1 === matchName2) {
        return "CROSS_MATCH";
      }
      return "NO_MATCH";
    },
  },
  {
    label: "Second Adoptee Parent's Name",
    getDisplay: (reg) =>
      displayName(reg?.adoptiveParent2FirstName, reg?.adoptiveParent2MiddleName, reg?.adoptiveParent2LastName),
    isMatch: (reg1, reg2) => {
      const selectedName =
        reg1?.adoptiveParent2FirstName + reg1?.adoptiveParent2MiddleName + reg1?.adoptiveParent2LastName;
      const matchName1 =
        reg2?.adoptiveParent1FirstName + reg2?.adoptiveParent1MiddleName + reg2?.adoptiveParent1LastName;
      const matchName2 =
        reg2?.adoptiveParent2FirstName + reg2?.adoptiveParent2MiddleName + reg2?.adoptiveParent2LastName;
      // if selectedNames and matchName1 have no data
      if (!selectedName || !matchName1) {
        return "NO_DATA";
      }

      // if selectedName match matchName1
      if (selectedName === matchName2) {
        return "MATCH";
      }

      // if selectedName cross matches matchName2
      if (selectedName === matchName1) {
        return "CROSS_MATCH";
      }
      return "NO_MATCH";
    },
  },
];

const BirthParentsFieldsToMatch = [
  {
    label: "First Birth Parent's Name",
    getDisplay: (reg) =>
      displayName(
        reg?.birthParent1CurrentFirstName,
        reg?.birthParent1CurrentMiddleName,
        reg?.birthParent1CurrentLastName
      ),
    isMatch: (reg1, reg2) => {
      const selectedName1 =
        reg1?.birthParent1CurrentFirstName + reg1?.birthParent1CurrentMiddleName + reg1?.birthParent1CurrentLastName;
      const matchName1 =
        reg2?.birthParent1CurrentFirstName + reg2?.birthParent1CurrentMiddleName + reg2?.birthParent1CurrentLastName;
      const matchName2 =
        reg2?.birthParent2CurrentFirstName + reg2?.birthParent2CurrentMiddleName + reg2?.birthParent2CurrentLastName;

      // if selectedNames1 and matchName1 have no data
      if (!selectedName1 || !matchName1) {
        return "NO_DATA";
      }

      // if selectedName1 match matchName1
      if (selectedName1 === matchName1) {
        return "MATCH";
      }

      // if selectedName1 cross matches matchName2
      if (selectedName1 === matchName2) {
        return "CROSS_MATCH";
      }
      return "NO_MATCH";
    },
  },
  {
    label: "Second Birth Parent's Name",
    getDisplay: (reg) =>
      displayName(
        reg?.birthParent2CurrentFirstName,
        reg?.birthParent2CurrentMiddleName,
        reg?.birthParent2CurrentLastName
      ),
    isMatch: (reg1, reg2) => {
      const selectedName =
        reg1?.birthParent2CurrentFirstName + reg1?.birthParent2CurrentMiddleName + reg1?.birthParent2CurrentLastName;
      const matchName1 =
        reg2?.birthParent1CurrentFirstName + reg2?.birthParent1CurrentMiddleName + reg2?.birthParent1CurrentLastName;
      const matchName2 =
        reg2?.birthParent2CurrentFirstName + reg2?.birthParent2CurrentMiddleName + reg2?.birthParent2CurrentLastName;
      // if selectedNames and matchName1 have no data
      if (!selectedName || !matchName1) {
        return "NO_DATA";
      }

      // if selectedName match matchName1
      if (selectedName === matchName2) {
        return "MATCH";
      }

      // if selectedName cross matches matchName2
      if (selectedName === matchName1) {
        return "CROSS_MATCH";
      }
      return "NO_MATCH";
    },
  },
  {
    label: "Birth Mother Alias",
    getDisplay: (reg) =>
      displayName(reg?.birthMotherAliasFirstName, reg?.birthMotherAliasMiddleName, reg?.birthMotherAliasLastName),
  },
];

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export default function RegistrationCompareMatchDialog({ open, onClose, matchRecord }) {
  const [existingMatch, setExistingMatch] = React.useState(null);
  const registrationOne = existingMatch?.adoptee;
  const registrationTwo = existingMatch?.relative;

  function getFormValuesFromNotes(matchedRecord) {
    const formValues = {
      notes: matchedRecord?.notes ?? "",
    };
    return formValues;
  }
  const [processingUpdate, setProcessingUpdate] = React.useState();
  const { addSuccessAlert, addErrorAlert } = useAlerts();
  const [notesOpen, setNotesOpen] = React.useState(false);
  const adminContext = useAdminContext();
  const matchStatus = React.useMemo(() => MatchStatus[existingMatch?.matchStatus], [existingMatch]);
  const classes = useStyles();

  React.useEffect(() => {
    if (matchRecord) {
      findExistingMatch(matchRecord?.adoptee.registrationId, matchRecord?.relative.registrationId).then(
        (respExistingMatch) => {
          respExistingMatch ? setExistingMatch(respExistingMatch) : setExistingMatch(matchRecord);
        }
      );
    }
  }, [matchRecord]);

  React.useEffect(() => {
    if (!open) {
      setExistingMatch(null);
    }
  }, [open]);

  function handleSaveNote(formik) {
    updateMatchNotes(existingMatch.matchId, { notes: formik.values.notes })
      .then(() => {
        addSuccessAlert("Notes saved");
      })
      .catch(() => {
        addErrorAlert("Error saving note - please try again");
      });
  }

  return (
    <>
      <div>
        <Dialog
          fullWidth
          maxWidth="md"
          open={open}
          onClose={() => {
            onClose();
          }}
          TransitionComponent={Transition}
          aria-labelledby="registration-match-dialog-title"
          aria-describedby="registration-match-dialog-description"
          classes={{ paper: classes.responsiveDialog }}
        >
          <DialogTitle id="registration-match-dialog-title">
            <span style={{ display: "flex", justifyContent: "space-between" }}>
              <span>
                Registration Match &nbsp;
                <HtmlTooltip
                  title={
                    <div>
                      <Typography className={classes.keyChart} variant="body1">
                        <CheckCircle style={{ color: "#008000" }} fontSize="small" /> Match
                      </Typography>
                      <Typography className={classes.keyChart} variant="body1">
                        <Block fontSize="small" /> No Data
                      </Typography>
                      <Typography className={classes.keyChart} variant="body1">
                        <Compare style={{ color: "#FFC136" }} fontSize="small" /> Partial Match
                      </Typography>
                      <Typography className={classes.keyChart} variant="body1">
                        <Shuffle style={{ color: "#008000" }} fontSize="small" /> Cross Match
                      </Typography>
                      <Typography className={classes.keyChart} variant="body1">
                        <Cancel style={{ color: "#ff0000" }} fontSize="small" /> No Match
                      </Typography>
                    </div>
                  }
                >
                  <Help />
                </HtmlTooltip>
              </span>
              <IconButton size="small" color="default" onClick={onClose} id="close" aria-label="Close Dialog">
                <Close />
              </IconButton>
            </span>
          </DialogTitle>
          <DialogContent id="registration-match-dialog-description">
            <Typography>Match Status: {MatchStatus[existingMatch?.matchStatus]?.label || "Searching..."}</Typography>
            {registrationOne && registrationTwo && (
              <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", marginTop: "1rem" }}>
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {displayName(
                    registrationOne.registrant.contactInformation.firstName,
                    registrationOne.registrant.contactInformation.middleName,
                    registrationOne.registrant.contactInformation.lastName
                  )}
                  <Typography variant="body1" style={{ fontWeight: 100 }}>
                    Registration ID:{" "}
                    <strong>
                      <Link
                        className={classes.registrationLink}
                        onClick={() =>
                          adminContext.openDetailsForUserFriendlyRegistrationId(registrationOne.userFriendlyId)
                        }
                      >
                        {registrationOne.userFriendlyId}
                      </Link>
                    </strong>
                  </Typography>
                </Typography>
                <Divider orientation="vertical" flexItem />
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {displayName(
                    registrationTwo.registrant.contactInformation.firstName,
                    registrationTwo.registrant.contactInformation.middleName,
                    registrationTwo.registrant.contactInformation.lastName
                  )}
                  <Typography variant="body1" style={{ fontWeight: 100 }}>
                    Registration ID:{" "}
                    <strong>
                      <Link
                        className={classes.registrationLink}
                        onClick={() =>
                          adminContext.openDetailsForUserFriendlyRegistrationId(registrationTwo.userFriendlyId)
                        }
                      >
                        {registrationTwo.userFriendlyId}
                      </Link>
                    </strong>
                  </Typography>
                </Typography>
              </div>
            )}
            {registrationOne ? (
              <>
                <Grid item xs={12}>
                  <Typography variant="body1" style={{ fontWeight: 600 }}>
                    <strong>Adoptee </strong>
                  </Typography>
                  <Divider />
                </Grid>
                <Grid container direction="row" justify="flex-start" alignItems="center">
                  {AdopteefieldsToMatch.map((field, index) => (
                    <RegistrationMatchComponent
                      key={index}
                      label={field.label}
                      registrationOne={registrationOne}
                      registrationTwo={registrationTwo}
                      getDisplay={field.getDisplay}
                      isMatch={field.isMatch}
                    />
                  ))}

                  <Grid item xs={12}>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                      <strong>Adoptee Parents </strong>
                    </Typography>
                    <Divider />
                  </Grid>
                  {AdopteeParentsFieldsToMatch.map((field, index) => (
                    <RegistrationMatchComponent
                      key={index}
                      label={field.label}
                      registrationOne={registrationOne}
                      registrationTwo={registrationTwo}
                      getDisplay={field.getDisplay}
                      isMatch={field.isMatch}
                    />
                  ))}
                  <Grid item xs={12}>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                      <strong>Birth Parents </strong>
                    </Typography>
                    <Divider />
                  </Grid>
                  {BirthParentsFieldsToMatch.map((field, index) => (
                    <RegistrationMatchComponent
                      key={index}
                      label={field.label}
                      registrationOne={registrationOne}
                      registrationTwo={registrationTwo}
                      getDisplay={field.getDisplay}
                      isMatch={field.isMatch}
                    />
                  ))}
                  {matchStatus && (
                    <Accordion expanded={notesOpen} style={{ width: "100%" }}>
                      <AccordionSummary
                        arial-label="Expand Notes"
                        aria-controls="notes-selection"
                        id="notes-selection"
                        onClick={() => setNotesOpen(!notesOpen)}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <Typography variant="body1" style={{ fontWeight: 600, margin: 0 }}>
                          Notes
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails style={{ flexDirection: "column" }}>
                        <div>
                          <Formik initialValues={getFormValuesFromNotes(existingMatch)}>
                            {(formik) => (
                              <div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                  <div style={{ flexGrow: 1 }}>
                                    <FormLabel htmlFor="notes"> Notes</FormLabel>
                                    <FormikTextField
                                      name="notes"
                                      variant="filled"
                                      multiline
                                      rows={4}
                                      rowsMax={10}
                                      fullWidth
                                    />
                                  </div>
                                  <div style={{ paddingLeft: 20, display: "flex", alignItems: "flex-end" }}>
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      size="small"
                                      autoFocus
                                      onClick={() => handleSaveNote(formik)}
                                    >
                                      Save
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Formik>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  )}
                </Grid>
              </>
            ) : (
              <div>
                <Skeleton style={{ height: 40 }} />
                <Skeleton style={{ height: 40 }} />
                <Skeleton style={{ height: 40 }} />
              </div>
            )}
          </DialogContent>

          <DialogActions>
            {matchStatus === MatchStatus.MATCH_SUGGESTED && (
              <Button
                enabled={!processingUpdate}
                onClick={() => {
                  setProcessingUpdate(true);
                  updateMatchStatus(existingMatch.matchId, MatchStatus.MATCH_REJECTED.value)
                    .then(setExistingMatch)
                    .then(adminContext.triggerDataResync)
                    .then(() => addSuccessAlert("Match rejected"))
                    .catch(() => addErrorAlert("There was an error completing the operation"))
                    .finally(() => setProcessingUpdate(false));
                }}
              >
                Reject
              </Button>
            )}
            {existingMatch && existingMatch.matchId == null && (
              <Button
                disabled={processingUpdate}
                onClick={() => {
                  setProcessingUpdate(true);
                  addMatchRecord(
                    registrationOne.registrationId,
                    registrationTwo.registrationId,
                    MatchStatus.MATCH_INPROCESS.value
                  )
                    .then((addedMatch) => {
                      setExistingMatch(addedMatch);
                      adminContext.setMatchRecord(addedMatch);
                      adminContext.setSelectedRegistration(null);
                      adminContext.triggerDataResync();
                      addSuccessAlert("Match added");
                    })
                    .catch(() => addErrorAlert("There was an error completing the operation"))
                    .finally(() => setProcessingUpdate(false));
                }}
              >
                Add Match
              </Button>
            )}
            {matchStatus === MatchStatus.MATCH_SUGGESTED && (
              <Button
                disabled={processingUpdate}
                onClick={() => {
                  setProcessingUpdate(true);
                  updateMatchStatus(existingMatch.matchId, MatchStatus.MATCH_INPROCESS.value)
                    .then(setExistingMatch)
                    .then(adminContext.triggerDataResync)
                    .then(() => addSuccessAlert("Match confirmed"))
                    .catch(() => addErrorAlert("There was an error completing the operation"))
                    .finally(() => setProcessingUpdate(false));
                  adminContext.setSelectedRegistration(null);
                }}
              >
                Confirm Match
              </Button>
            )}
            {matchStatus === MatchStatus.MATCH_INPROCESS && (
              <Button
                enabled={!processingUpdate}
                onClick={() => {
                  setProcessingUpdate(true);
                  adminContext.setSelectedRegistration(null);
                  updateMatchStatus(existingMatch.matchId, MatchStatus.MATCH_READY.value)
                    .then(setExistingMatch)
                    .then(adminContext.triggerDataResync)
                    .then(() => addSuccessAlert("Match completed."))
                    .catch(() => addErrorAlert("There was an error completing the operation"))
                    .finally(() => setProcessingUpdate(false));
                }}
              >
                Complete
              </Button>
            )}

            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
